import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_conducted_a_risk_assessment_or_testing_to_determine'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_conducted_a_risk_assessment_or_testing_to_determine',
  name: 'Has the facility conducted a risk assessment or testing to determine if high noise levels are present? ',
  description:
    '"Noise testing" refers to measuring sound pressure exposure levels in the facility. Specifically in areas where noise exposure levels are the highest (e.g. next to loud machinery).  The purpose is to determine if noise programs or controls will be necessary.   Noise measurements with a sound level meter or dosimeters may or may not be necessary to determine if high noise areas exist. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13420,
  sectionId: '2.2.9.1',
  impactArea: 'Risk Assessment',
  impactAreaId: 'RISK_ASSESSMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
